/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useState, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Logo, Title, List, Item, Settings, SubTitle, Content, Version, TextVersion, SubTitleVersion } from './styles';
import logo from '../Logo/texel-logo.png'
import Icon from '../Icon';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext } from 'store/context';
import { useHistory } from 'react-router-dom';
import packageJsonInfo from "../../../package.json";

export default function Menu(props) {
  const setShowProfile = props.showProfile;

  const [showDashboard, setShowDashboard] = useState(false);
  const [showEnquires, setShowEnquires] = useState(false);
  const [showPolicies, setShowPolicies] = useState(false);
  const [showClaims, setShowClaims] = useState(false);
  const [showPayments, setShowPayments] = useState(false);
  const [showRenewals, setShowRenewals] = useState(false);
  const [showManagement, setShowManagement] = useState(false);
  const [showProcessAdmin, setShowProcessAdmin] = useState(false);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const authContext = useContext(GlobalAuthContext);
  const packageJsonInfo = require('../../../package.json');

  const history = useHistory();

  const goToHomePage = () => {
    history.push('home');
  }
  
  function requestAccess(username, dsDomPrivilege, idDomain, idPersonRelation, idOperation, menu) {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestAccess(username, dsDomPrivilege, idDomain, idPersonRelation, idOperation)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.ret_code == "200") {
          menu(true)
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    requestAccess("", "READ", "317", null, null, setShowDashboard)
    requestAccess("", "READ", "318", null, null, setShowEnquires)
    requestAccess("", "READ", "319", null, null, setShowPolicies)
    requestAccess("", "READ", "320", null, null, setShowClaims)
    requestAccess("", "READ", "321", null, null, setShowPayments)
    requestAccess("", "READ", "322", null, null, setShowRenewals)
    requestAccess("", "READ", "462", null, null, setShowManagement)
    requestAccess("", "READ", "1079", null, null, setShowProcessAdmin)
  }, []);

  return (
    <Content>
      <Container>
        <Logo src={logo} onClick={() => goToHomePage()}></Logo>
        <Title>Menu</Title>
        <List>
          {showDashboard ? <NavLink to="/home" activeClassName='active' exact={true}><Item><Icon name="dashboardBlue" />Dashboard</Item></NavLink> : ''}
          {showEnquires ? <NavLink to="/enquiries?hideInactiveTransactions=true&hideExecutedTransactions=true" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('enquiries_filter') }}><Item><Icon name="enquiriesBlue" />Enquiries</Item></NavLink> : ''}
          {showPolicies ? <NavLink to="/policies" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('policies_filter') }}><Item><Icon name="policiesBlue" />Policies & Endorsements</Item></NavLink> : ''}
          {showClaims ? <NavLink to="/claims" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('claims_filter') }}><Item><Icon name="claimsBlue" />Claims</Item></NavLink> : ''}
          {showPayments ? <NavLink to="/payments?hideAbortedTransactions=true&hideDirectPayment=true&hidePaidPayment=true" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('payment_filter') }}><Item><Icon name="paymentsBlue" />Payments</Item></NavLink> : ''}
          {showRenewals ? <NavLink to="/renewals" activeClassName='active' exact={true}><Item><Icon name="renewalsBlue" />Renewals</Item></NavLink> : ''}
          {showManagement ? <NavLink to="/management" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('management_filter') }}><Item><Icon name="managementBlue" />Management</Item></NavLink> : ''}
          {showProcessAdmin ? <NavLink to="/process-admin" activeClassName='active' exact={true} onClick={() => { localStorage.removeItem('process_admin_filter') }}><Item><Icon name="Gear" />Process Admin</Item></NavLink> : ''}
        </List>
        <Settings>
          <List>
            <SubTitle>Settings</SubTitle>
            <Item onClick={() => { setShowProfile(true) }}><Icon name="user" />My Account</Item>
            <NavLink to="/login" onClick={() => { sessionStorage.removeItem('texel-export-list-report') }}><Item><Icon name="logout" />Logout</Item></NavLink>
          </List>
        </Settings>
        <Version>
          <SubTitleVersion>Version</SubTitleVersion>
          <TextVersion>{packageJsonInfo.version}</TextVersion>
        </Version>
      </Container>
    </Content>
  );
}
